(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('InstitucionDetailController', InstitucionDetailController);

    InstitucionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Institucion'];

    function InstitucionDetailController($scope, $rootScope, $stateParams, previousState, entity, Institucion) {
        var vm = this;

        vm.institucion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:institucionUpdate', function(event, result) {
            vm.institucion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
